import { CLOUDINARY_INTEL_BASE_URL } from "../../../utils/enum";
import DemoTouchPoint from "../../intel/onboarding-screens/onboarding/VideoOpenerStrip";

const BENEFITS = [
  {
    title: "Seamlessly Build Your List:",
    text: "Easily add companies to your workspace from anywhere - whether you are searching through shipments and products.",
    comingSoon: false,
  },
  {
    title: "Score and Enrich Opportunities:",
    text: `Instantly add crucial details like verified contact data, pricing, revenue, and employee counts to your workspace, and use these deep insights to score and prioritize your best-fit companies.`,
    comingSoon: false,
  },
  {
    title: "Download or Track with Ease:",
    text: "Shortlist your top prospects and export their enriched data via download, or simply bookmark them to continuously monitor updates in real time.",
    comingSoon: false,
  },
  {
    title: "Streamline Your Outreach:",
    text: "Turn data into action by initiating direct outreach to your shortlisted companies.",
    comingSoon: true,
  },
];

const WorkspaceEmptyState = ({ userName }: { userName: string }) => (
  <div className="tw-w-full tw-h-[calc(100vh-48px)] tw-flex tw-flex-col tw-justify-center tw-items-center">
    <div className="tw-w-[632px] tw-m-auto">
      {userName && <h2 className="tw-text-base tw-font-semibold tw-text-gray-900 tw-mb-1">Welcome {userName}</h2>}
      <p className="tw-text-sm tw-text-gray-500 tw-mb-4">Lets understand the benefits of workspace and the process to create it</p>
      <div className="tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-p-4">
        <div className="tw-flex tw-justify-center tw-items-center tw-py-4">
          <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1779346862/intel/misc/workspace_emptystate_illustration_orhekq.svg`} alt="workspace-empty-state" height={200} />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-4">
          {BENEFITS.map((benefit) => (
            <div key={benefit.title} className="tw-flex tw-items-center tw-gap-2">
              <svg className="tw-flex-shrink-0 tw-mt-0.5" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#12b733">
                <path d="m100-180 230-300-230-300.38h493.46q17.07 0 32.34 7.34 15.28 7.35 25.12 20.81L860-480 651.31-208.16q-9.85 13.47-25.12 20.81-15.27 7.35-32.34 7.35H100Zm120-60h374.23q3.08 0 5.39-1.15 2.3-1.16 4.23-3.47L785-480 603.85-715.77q-1.93-2.31-4.23-3.46-2.31-1.15-5.39-1.15H220L405-480 220-240Zm282.69-240.38Z" />
              </svg>
              <span className="tw-text-sm tw-text-gray-700 tw-flex tw-justify-between tw-items-center tw-gap-2">
                <span>
                  <span className="tw-font-semibold">{benefit.title}</span> {benefit.text}
                </span>
                {benefit.comingSoon && <span className="tw-flex-shrink-0 tw-ml-2 tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-h-fit tw-rounded-[10px] tw-text-xs tw-font-medium tw-bg-orange-100 tw-text-orange-600">coming soon</span>}
              </span>
            </div>
          ))}
        </div>
        <div className="tw-flex tw-justify-center tw-mt-3">
          <DemoTouchPoint module="workspace" label="Learn how to use workspace" className="tw-rounded-r-xl" />
        </div>
      </div>
    </div>
  </div>
);

export default WorkspaceEmptyState;
